import React, { useEffect, useState } from 'react';
import { ModernStatWidget } from '../../Components/DashboardCard';
import axiosInstance from '../../../../../Services/axiosCommon';

const Vehicle = () => {
  const [data, setData] = useState([]);

  async function getData() {
    try {
      const res = await axiosInstance.get(`/new-dashboard/vehicles-and-equipments`);
      setData(res?.data || []);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getData();
  }, []);

  const VehicleIcon = (
    <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M8 17a2 2 0 100 4 2 2 0 000-4zm10 0a2 2 0 100 4 2 2 0 000-4zM4 9h11l3 4v4H4V9z" />
    </svg>
  );

  return (
    <ModernStatWidget
      title="Vehicles"
      value={data?.vehicles || 0}
      icon={VehicleIcon}
      bgColor="bg-blue-500/10"
      iconColor="text-blue-600"
    />
  );
};

export default Vehicle;